import { readTerminalConfig } from "./terminal-theme";

const LEGACY_CART_KEY = "cart";
const CART_PREFIX = "consumerRuntimeCart";

const toText = (value: unknown) => String(value ?? "").trim();

function resolveLocationScopeId(): string {
  try {
    const config = readTerminalConfig() as Record<string, unknown>;
    const directLocationId = toText(config?.locationId);
    if (directLocationId) return directLocationId;

    const nestedLocationId = toText((config?.location as Record<string, unknown> | undefined)?.id);
    if (nestedLocationId) return nestedLocationId;

    const sellingPointId = toText(config?.sellingPointId);
    if (sellingPointId) return `selling-point:${sellingPointId}`;
  } catch {
    // ignore
  }
  return "global";
}

export function getConsumerRuntimeCartStorageKey(): string {
  return `${CART_PREFIX}:${resolveLocationScopeId()}`;
}

export function readStoredCart<T = any[]>(): T {
  const scopedKey = getConsumerRuntimeCartStorageKey();
  try {
    const scopedRaw = localStorage.getItem(scopedKey);
    if (scopedRaw) return JSON.parse(scopedRaw) as T;

    const legacyRaw = localStorage.getItem(LEGACY_CART_KEY);
    if (legacyRaw) {
      const parsed = JSON.parse(legacyRaw) as T;
      localStorage.setItem(scopedKey, JSON.stringify(parsed));
      localStorage.removeItem(LEGACY_CART_KEY);
      return parsed;
    }
  } catch {
    // ignore
  }
  return [] as T;
}

export function writeStoredCart(value: unknown): void {
  try {
    localStorage.setItem(getConsumerRuntimeCartStorageKey(), JSON.stringify(value ?? []));
    localStorage.removeItem(LEGACY_CART_KEY);
  } catch {
    // ignore
  }
}

export function clearStoredCart(): void {
  try {
    localStorage.removeItem(getConsumerRuntimeCartStorageKey());
    localStorage.removeItem(LEGACY_CART_KEY);
  } catch {
    // ignore
  }
}
